import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { hasPermission } from "~/store/usePermissionStore";
import { CustomUiExtensionPage } from "~/pages/custom-ui-extension";
export const Route = createFileRoute("/_dashboard/$datasetSlug/plugins/$id")({
  validateSearch: (search: Record<string, unknown>): { page?: string; path?: string } => ({
    page: typeof search.page === "string" ? search.page : undefined,
    path: typeof search.path === "string" ? search.path : undefined,
  }),
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions());
    if (!hasPermission({ role: session.user?.role, permissions: session.user?.permissions }, "plugins", "view"))
      throw redirect({ to: "/$datasetSlug/chats", params: { datasetSlug: params.datasetSlug } });
  },
  component: CustomUiExtensionPage,
});
